//---- components ---------
//---- mixins -------------
//---- services -----------
import { ajaxService } from '@/app/services';
//---- other --------------
import { environment } from '@/environment/environment.js';
import URL from '../common/URL';
//---- 3rd-parties --------

/**
 * @description Logger class
 * This is responsible for logging of all kind of stuff in the application
 * Default, we are using the console api for logging and this provides the basic level of logging such as
 * you can use the available method of console in developement but in production these will be replaced with empty methods
 * This can be extended with the help of adding Log level functionality
 */
class AppLogger {
  /**
   * @constructor AppLogger
   */
  constructor() {
    /** Initializing the configuration of logger */
    this.initLogger();
  }

  /**
   * @description Initializing the configuration such as if environment is production then all log method will be replaced with empty methods
   * except logToServer, which will be responsible for logging the important stuff on server
   */
  initLogger() {
    /** Checking the environment */
    if (environment !== 'production') {
      this.log = console.log.bind(console);

      this.debug = console.debug.bind(console);

      this.info = console.info.bind(console);

      this.warn = console.warn.bind(console);

      this.error = console.error.bind(console);

      this.logToServer = this.error;
    } else {
      /** In case of production replace the functions definition */
      this.log = this.debug = this.info = this.warn = this.error = () => {};

      this.logToServer = err => {
        /** temp added to print in the console during production */
        console.error(err); //
        /** TODO: API integration for logging to server or any custom logic in case of Production environment */
      };
    }
  }

  // alert only if not in production environment. These alerts should be seend by 
  // developpers only
  alertDev(message) {
    if (environment !== 'production')
      alert(message)
  }

  // report an error to the server to be logged
  // @param data can contain any of these properties: 
  //             msg
  //             url
  //             responseData
  //             message
  //             details
  //             name
  //             fileName
  //             lineNumber
  //             columnNumber
  //             stack
  //             line
  //             window
  //             version
  logClientSideErrorToServer(data) {
    // the fields in an error are non-enumerable
    // so we need to create a new object
    // see: https://stackoverflow.com/a/26199752/1401409
    if (data instanceof Error)
      data = JSON.parse(JSON.stringify(data, Object.getOwnPropertyNames(data)))

    if (environment !== 'production')
      console.trace(data)
    return ajaxService.postUrlEncodedData(URL.clientSideErrorLoggerUrl, {data: JSON.stringify(data)});
  }

  logClientSideErrorWithStackToServer(data) {
    try {
      throw new Error('');
    }
    catch (error) {
      const stack = error.stack || '';
      data.stack = stack;
      return this.logClientSideErrorToServer(data)
    }
  }
}

/** Creating the instance of logger */
export default new AppLogger();